export default __webpack_public_path__ + "static/media/icons8-link2.6e199ebd.svg";